<template>
  <section id="dashboard-ecommerce">
    <b-overlay :show="onProgress">
      <b-row class="match-height">
        <b-col cols="12">
          <statistics :data="data.statistics"/>
        </b-col>
      </b-row>
      <b-row class="match-height">
        <b-col md="6" v-if="!onProgress && data.openApprovals.length">
          <users :table-data="data.openApprovals" title="کاربران دارای بیشترین مصوبه باز"/>
        </b-col>
        <b-col md="6" v-if="!onProgress && data.completedApprovals.length">
          <users :table-data="data.completedApprovals" title="کاربران داری بیشترین مصوبه تکمیل شده"/>
        </b-col>
        <b-col md="6" v-if="!onProgress && data.inboxAgendas.length">
          <users :table-data="data.inboxAgendas" title="کاربران با بیشترین عضویت در جلسه"/>
        </b-col>
      </b-row>
    </b-overlay>

  </section>
</template>

<script>
import { BRow, BCol, BOverlay } from 'bootstrap-vue'
import { doubleRaf } from '@/libs/utils'
import Statistics from './statistics.vue'
import users from './usersTable.vue'

export default {
  components: {
    BRow,
    BCol,
    Statistics,
    users,
    BOverlay,
  },
  data() {
    return {
      data: {},
      onProgress: false,
    }
  },
  created() {
    // data
    this.onProgress = true

    this.$http.get('/reports/agendas')
        .then(response => {
          this.data = response.data
          doubleRaf(() => {
            this.onProgress = false
          })
        })
  },
}
</script>
